import React from "react";

import { Row as AntRow, RowProps as AntRowProps } from "antd";

type RowProps = AntRowProps & {
  dataTestId?: string;
};

export const Row = ({ dataTestId, gutter, children, ...props }: RowProps) => (
  <AntRow data-testid={dataTestId} gutter={gutter !== undefined ? gutter : [{ xs: 8, sm: 8, md: 16 }, 16]} {...props}>
    {children}
  </AntRow>
);

export default Row;
